import { AUTH_LOGIN_PATH, AUTH_SIGN_UP_PATH } from "@src/appV2/Auth";
import { useDefaultAuthScreen } from "@src/appV2/Auth/LoginSignUp/hooks/useDefaultAuthScreen";
import { AuthMode } from "@src/appV2/Auth/LoginSignUp/libs";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";

import { EmailVerify } from "../login/emailVerify";
import { VerifyLogin } from "../login/verifyLogin";
import { getAppV2Route } from "../routing/constant/appV2Routes";
import { WelcomeRouterPath } from "../routing/constant/welcomeRoute";

export function WelcomeRoute(): JSX.Element {
  const location = useLocation();
  const { defaultAuthMode } = useDefaultAuthScreen();

  return (
    <Switch>
      <Route exact path={WelcomeRouterPath.LANDING_PAGE}>
        <Redirect
          to={{
            pathname: getAppV2Route(
              defaultAuthMode === AuthMode.LOGIN ? AUTH_LOGIN_PATH : AUTH_SIGN_UP_PATH
            ),
            state: location.state,
          }}
        />
      </Route>

      <Route exact path={WelcomeRouterPath.LOGIN}>
        <Redirect to={{ pathname: getAppV2Route(AUTH_LOGIN_PATH), state: location.state }} />
      </Route>

      {/**
       * When using log in via email, the API/Firebase's email link points to
       * LOGIN_VERIFY_LINK. This is not part of /v2 auth refactoring.
       */}
      <Route exact path={WelcomeRouterPath.LOGIN_VERIFY_LINK} component={VerifyLogin} />

      {/* This route is used for auto-login links which are generated via HCF Admin App */}
      <Route exact path={WelcomeRouterPath.LOGIN_EMAIL_VERIFY} component={EmailVerify} />
    </Switch>
  );
}
